import React, { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormContextProvider, TabPanelContext, TabPanelContextProvider } from "../../context/ContextIndex";
import { AppFormRootContainer, TabPanel } from "../../components";
import DeviceCreate from "./device/create/DeviceCreate";
import DeviceList from "./device/list/DeviceList";
import { getDeviceDefaultValue, getDeviceSchema } from "./device/create/schema";
import ReplacementDeviceView from "./replacement-device/ReplacementDeviceView";

const DeviceGroupView = ({ displayList }) => {
  return displayList ? (
    <DeviceList />
  ) : (
    <TabPanelContextProvider>
      <AppFormRootContainer>
        <DeviceTabContent />
      </AppFormRootContainer>
    </TabPanelContextProvider>
  );
};

const DeviceTabContent = () => {
  const { t } = useTranslation();
  const deviceRef = useRef();
  const _tabContextObject = useContext(TabPanelContext);
  const _tabContext = _tabContextObject.getTabFormContext();

  const deviceDefaultValue = getDeviceDefaultValue(_tabContext.data?.device);

  const [deviceFormData, setDeviceFormData] = useState({
    deviceSchema: getDeviceSchema({deviceTypeList : [], serviceTypeList : []}),
    appformdata: null,
  });
  

  const handleTabChange = (newTab) => {
    try {
      if (_tabContext.tabIndex === "0") {
        if (deviceRef.current) {
          deviceRef.current.tabChangeHandler(newTab);
        }
      } else {
        _tabContextObject.setTabFormContext({
          tabIndex: newTab,
        });
      }
    } catch (e) {
      alert(e);
    }
  };

  return (
    <TabPanel
      tabs={[
        {
          icon: "",
          label: t("createDevice.device"),
          children: (
            <FormContextProvider
              schema={deviceFormData.deviceSchema}
              defaultValues={deviceDefaultValue}
              appformdata={deviceFormData?.appformdata}
            >
              <DeviceCreate
                ref={deviceRef}
                setDeviceFormData={setDeviceFormData}
                setIsFormValid
              />
            </FormContextProvider>
          ),
        },
        {
          icon: "",
          label: t("createDevice.replacement%Device"),
          children: <ReplacementDeviceView />,
        },
      ]}
      selectedTab={_tabContext.tabIndex}
      onTabChange={handleTabChange}
    />
  );
};

export default DeviceGroupView;
